<div class="content">
  <div class="document" *ngFor="let document of documents">
    <div class="document-content">
      <div class="document-avatar"[style.background-color]="getColorFromName(document.name)">{{document.name.substring(0,1)}}</div>
      <div class="document-text">
        <div class="document-name">{{document.name}}</div>
        <div class="document-desc">{{document.description}}</div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="onEdit(document)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button  (click)="onDelete(document)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div  class="add-new-container" *ngIf="mode === 'page'" >
    <button class="page" mat-fab color="primary" (click)="onEdit(null)">
   + Add new
    </button>
  </div>
  <div  class="add-new-container-dialog" *ngIf="mode === 'dialog'" >
    <button class="page" mat-fab color="primary" (click)="onEdit(null)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

